import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { REHYDRATE } from "redux-persist";
import { WalletState, WalletInfo } from "./walletTypes";
import {
  fetchWalletRequest,
  fetchWalletSuccess,
  fetchWalletFailure,
  hydrateWalletFromLogin,
  clearWallet,
} from "./walletActions";

const initialState: WalletState = {
  info: null,
  transactions: [],
  loading: false,
  error: null,
};

const walletSlice = createSlice({
  name: "wallet",
  initialState,
  reducers: {
    // agar kabhi direct state update karna ho
    setWalletInfo(state, action: PayloadAction<WalletInfo | null>) {
      state.info = action.payload;
    },
  },
  extraReducers: (builder) => {
    // redux-persist se hydration
    builder.addCase(REHYDRATE as any, (state, action: any) => {
      const incoming = action.payload?.wallet;
      if (!incoming) return;

      state.info = incoming.info ?? null;
      state.transactions = Array.isArray(incoming.transactions)
        ? incoming.transactions
        : [];
      state.loading = false;
      state.error = null;
    });

    // API triggers
    builder
      .addCase(fetchWalletRequest, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchWalletSuccess, (state, action) => {
        state.loading = false;
        state.error = null;
        state.info = action.payload.info;
      })
      .addCase(fetchWalletFailure, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    // login se hydrate
    builder.addCase(hydrateWalletFromLogin, (state, action) => {
      const { userId, walletInfo } = action.payload;
      if (!walletInfo) {
        state.info = null;
        return;
      }
      state.info = {
        userId,
        hasWallet: Boolean(walletInfo.hasWallet),
        walletPublicKey: walletInfo.walletPublicKey ?? null,
        walletType: walletInfo.walletType ?? null,
        isKyc: Boolean(walletInfo.isKyc),
        isMinKyc: Boolean(walletInfo.isMinKyc),
        kycState: walletInfo.kycState ?? null,
        activeBalance: Number(walletInfo.activeBalance ?? 0),
        encWalletToken: walletInfo.encWalletToken ?? null,
        encWalletTokenIV: walletInfo.encWalletTokenIV ?? null,
        expiryTime: walletInfo.expiryTime ?? null,
      };
    });

    builder.addCase(clearWallet, (state) => {
      state.info = null;
      state.transactions = [];
      state.loading = false;
      state.error = null;
    });
  },
});

export const { setWalletInfo } = walletSlice.actions;
export default walletSlice.reducer;
